<template>
  <div class="container mt-4">
    <b-card title="Panel de Control de Componentes" class="shadow">
      <!-- Selector de Componente -->
      <b-form-group label="Seleccionar Componente:" label-for="component-select">
        <b-form-select 
          id="component-select"
          v-model="selectedComponent"
          :options="componentOptions"
          @change="loadComponentControls"
          class="mb-4"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>
              -- Seleccione un componente --
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>

      <!-- Controles del Componente Seleccionado -->
      <div v-if="selectedComponent">
        <h5 class="mb-3">Controles para: {{ selectedComponent }}</h5>
        
        <b-list-group>
          <b-list-group-item 
            v-for="(isVisible, controlName) in componentControls" 
            :key="controlName"
            class="d-flex justify-content-between align-items-center"
          >
            <span>{{ getControlLabel(controlName) }}</span>
            <b-form-checkbox 
              v-model="componentControls[controlName]"
              switch
              @change="updateControl(controlName, $event)"
            >
              {{ componentControls[controlName] ? 'Visible' : 'Oculto' }}
            </b-form-checkbox>
          </b-list-group-item>
        </b-list-group>

        <!-- Botón para guardar todos los cambios -->
        <div class="mt-4">
          <b-button 
            variant="primary" 
            @click="saveAllControls"
            :disabled="!hasChanges"
          >
            <b-icon-save class="mr-2"></b-icon-save>
            Guardar Cambios
          </b-button>
          
          <b-button 
            variant="outline-secondary" 
            @click="resetChanges"
            class="ml-2"
            :disabled="!hasChanges"
          >
            Cancelar
          </b-button>
        </div>
      </div>

      <!-- Mensaje cuando no hay componente seleccionado -->
      <div v-else class="text-center text-muted py-4">
        <b-icon-gear font-scale="3" class="mb-3"></b-icon-gear>
        <p>Seleccione un componente para configurar sus controles</p>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'ButtonAdminPanel',
  
  data() {
    return {
      selectedComponent: null,
      componentControls: {},
      originalControls: {},
      hasChanges: false
    }
  },
  
  computed: {
    componentOptions() {
      // Lista de componentes que podemos controlar
      return [
        { value: 'BalanceNiif', text: 'Balance NIIF' },
        // Podemos agregar más componentes aquí después
        // { value: 'OtroComponente', text: 'Otro Componente' }
      ]
    }
  },
  
  methods: {
    getControlLabel(controlName) {
      const labels = {
        'Notas': 'Checkbox Notas',
        'Balance': 'Checkbox Balance',
        'Comparativo': 'Checkbox Comparativo',
        'Consolidado': 'Checkbox Consolidado',
        'Informacion': 'Checkbox Información'
      }
      return labels[controlName] || controlName
    },
    
    loadComponentControls() {
      if (!this.selectedComponent) return
      
      const currentControls = this.$store.getters.getComponentControls(this.selectedComponent)

      this.componentControls = { ...currentControls }
      this.originalControls = { ...currentControls }
      this.hasChanges = false
    },
    
    updateControl() {

      this.hasChanges = true
    },
    
    saveAllControls() {
      if (!this.selectedComponent) return
      
      this.$store.commit('setComponentControls', {
        componentName: this.selectedComponent,
        controls: { ...this.componentControls }
      })
      
      this.originalControls = { ...this.componentControls }
      this.hasChanges = false
      
      this.$bvToast.toast('Controles guardados exitosamente', {
        title: 'Éxito',
        variant: 'success',
        solid: true
      })
    },
    
    resetChanges() {
      this.componentControls = { ...this.originalControls }
      this.hasChanges = false
    }
  },
  
  watch: {
    componentControls: {
      deep: true,
      handler(newVal) {
        const changes = Object.keys(newVal).some(key => 
          newVal[key] !== this.originalControls[key]
        )
        this.hasChanges = changes
      }
    }
  }
}
</script>

<style scoped>
.list-group-item {
  transition: all 0.3s ease;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}
</style>